export default [
  {
    name: 'Login',
    path: '/login',
    component: () => import(/* webpackChunkName: "notAuthenticated" */'@core/apps/auth/Login.vue'),
    meta: { title: 'Mais - Login', subject: 'Auth', redirectIfLoggedIn: true },
  },
  {
    name: 'ForgotPassword',
    path: '/esqueci-minha-senha',
    component: () => import(/* webpackChunkName: "notAuthenticated" */'@core/apps/auth/ForgotPassword.vue'),
    meta: { title: 'Mais - Esqueci minha senha', subject: 'Auth' },
  },
]
